import { isPresent, Nullish } from '@/shared/utils/typescript';

export interface RoleId {__roleId: number}

export default class Role {
  id: RoleId | null = null;
  description = '';
  linked = false;

  static withIdAndDescription(id: Nullish<RoleId>, description: Nullish<string>): Role | null {
    if (!isPresent(id) || !description) return null;
    const role = new Role();
    role.id = id;
    role.description = description;
    return role;
  }
}
